/**
 * Prepare / Send Email with no recipient — same rule as the backend
 * `noRecipientPrepareResult` in functions/helpers/contactEmail.js.
 *
 * There is nothing to write, so this is not an onFail toggle:
 * they leave this agent, stay in the list, no credits.
 */

export const NO_RECIPIENT_OUTCOME = {
  leavesAgent: true,
  staysInDatabase: true,
  tag: 'Failed',
  creditsCharged: false,
};

export function noRecipientNote({ prepareMode = false, decisionMakerOnly = false, jobName } = {}) {
  const step = prepareMode ? 'Prepare Email' : 'Send Email';
  const failStatus = jobName ? `${String(jobName).trim()} Failed` : "this agent's Failed status";
  const body = `${step} cannot write a mail. They leave this agent's queue immediately with status "${failStatus}". No credits charged.`;
  if (decisionMakerOnly) {
    return {
      title: 'No decision-maker email?',
      body: `${body} This template is set to skip when there is no decision-maker address. Company inboxes (info@) are not used.`,
    };
  }
  return {
    title: 'No email after research and finder?',
    body,
  };
}

export function noRecipientChipTitle(prepareMode = false, jobName) {
  const step = prepareMode ? 'Prepare Email' : 'Send Email';
  const failStatus = jobName ? `${String(jobName).trim()} Failed` : "this agent's Failed status";
  return `No address to write to — ${step} cannot run. They leave the queue with status "${failStatus}", no credits.`;
}
